import React from 'react'
import Link from 'next/link';
import Image from 'next/image';
import appimg from '../images/our_services/application_image.png';
import appimg2x from '../images/our_services/application_image2x.png';
import CLPInstall from './CLPInstall';
import EarthingInstall from './EarthingInstall';
import ESEinstall from './ESEinstall';
import SoiltestPage from './SoiltestPage';

// Each service is now a real route under /ourservices/<slug>.
export const SERVICES = [
  { slug: 'ese-installation',      label: 'E.S.E INSTALLATION',     content: <ESEinstall/> },
  { slug: 'earthing-installation', label: 'EARTHING INSTALLATION',  content: <EarthingInstall/> },
  { slug: 'clp-installation',      label: 'CLP INSTALLATION',       content: <CLPInstall/> },
  { slug: 'soil-testing',          label: 'Soil Testing Services',  content: <SoiltestPage/> },
];

// `active` is the current service slug (comes from the route).
const Installation = ({ active = 'ese-installation' }) => {
  const current = SERVICES.find((s) => s.slug === active) || SERVICES[0];

  const parentCls = (slug) =>
    active === slug
      ? 'bg-ashblack p-5 text-white flex text-2xl'
      : 'p-5 text-white flex text-2xl';

  return (
    <div className="container mx-auto flex flex-col md:flex-row lg:flex-row max-w-screen-xl justify-start">
      <div className="left-column w-full md:w-2/5 lg:w-2/5 mb-4 border-r bg-ashred">
        <div className="top-section mb-4">
          {SERVICES.map((s) => (
            <div key={s.slug} className={parentCls(s.slug)}>
              <Link
                href={`/ourservices/${s.slug}`}
                className="text-white py-2 px-1 md:px-2 lg:px-4 rounded"
              >
                {s.label}
              </Link>
            </div>
          ))}
        </div>
        <div className="h-40"></div>
        <div className="bottom-section mt-4 p-4">
          <Image
            priority
            src={appimg}
            alt="ashlok services design image"
            srcSet={`${appimg} 1x, ${appimg2x}2x`}
            className="w-full"
          />
        </div>
      </div>

      <div className="right-column w-full md:w-3/5 lg:w-3/5 pl-4 pb-4 pt-4 pr-2 lg:pr-0">
        {current.content}
      </div>
    </div>
  );
};

export default Installation;
